import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/accInfos/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/accInfos/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/accInfos/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/accInfos/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/accInfos/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/accInfos/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/accInfos/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
